export const CHAT_PENDING_STATUSES = new Set([
  'queued',
  'pending',
  'processing',
  'created',
  'running',
  'in_progress',
  'in-progress',
  'started',
  'executing',
]);

export const CHAT_TERMINAL_STATUSES = new Set([
  'fulfilled',
  'failed',
  'errored',
  'error',
  'canceled',
  'cancelled',
  'complete',
  'completed',
  'done',
  'finished',
  'success',
]);

export const CHAT_MAX_PENDING_AGE_MS = 10 * 60 * 1000;
export const CHAT_ORPHAN_QUEUED_MS = 2 * 60 * 1000;

export function getChatRequestStartMs(request, now = Date.now()) {
  const startIso = request?.created_at || request?.modified_at || request?.history_updated_at || null;
  if (!startIso) return now;
  const startMs = new Date(startIso).getTime();
  return Number.isNaN(startMs) ? now : startMs;
}

/** True while a request should keep the client poll loop running. */
export function isActiveChatRequest(request) {
  if (!request?.request_id) return false;
  const status = String(request.status || '').toLowerCase();
  if (CHAT_TERMINAL_STATUSES.has(status)) return false;
  if (CHAT_PENDING_STATUSES.has(status)) return true;
  return status !== '';
}

/** True when a request should disable the composer (guards stale and orphaned queue rows). */
export function isBlockingChatRequest(request, now = Date.now()) {
  if (!request?.request_id) return false;
  const status = String(request.status || '').toLowerCase();
  if (!CHAT_PENDING_STATUSES.has(status)) return false;

  const startMs = getChatRequestStartMs(request, now);
  const ageMs = now - startMs;
  if (ageMs > CHAT_MAX_PENDING_AGE_MS) return false;
  if (status === 'queued' && (request.history_count || 0) === 0 && ageMs > CHAT_ORPHAN_QUEUED_MS) {
    return false;
  }
  return true;
}

/** Decide whether another request/get poll should run for the given ids. */
export function shouldContinueRequestPolling(updates, requestedIds) {
  const ids = Array.isArray(requestedIds) ? requestedIds.filter(Boolean) : [];
  if (ids.length === 0) return false;
  const rows = Array.isArray(updates) ? updates : [];
  if (rows.length === 0) return true;
  return rows.some(isActiveChatRequest);
}
